import React, { useCallback } from "react";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import cx from "classnames";
import { Icon } from "../Icon/Icon";

export const SmallControlledNumberInput = ({
  value,
  min,
  max,
  disabled,
  onChange,
}) => {
  const handlePlusClick = useCallback(() => {
    if (disabled) {
      return;
    }
    onChange(!max || value < max ? +value + 1 : value);
  }, [disabled, max, onChange, value]);

  const handleMinusClick = useCallback(() => {
    if (disabled) {
      return;
    }
    onChange(value > min ? +value - 1 : value);
  }, [disabled, min, onChange, value]);

  const handleChange = useCallback(
    (e) => {
      const newValue = +e.target.value;
      if (newValue < min) {
        onChange(min);
        return;
      }
      if (newValue > max) {
        onChange(max);
        return;
      }
      onChange(newValue);
    },
    [max, min, onChange],
  );

  return (
    <InputGroup className="d-flex flex-nowrap">
      <InputGroupText
        className="g-gray-100 p-1"
        onClick={handleMinusClick}
        data-testid="-"
        style={{ height: "1rem" }}
      >
        <Icon
          iconName="minus"
          className={cx("icon-8 ", {
            "cursor-not-allowed opacity-20 disabled":
              +min === +value || disabled,
            "cursor-pointer": !(+min === +value),
          })}
        />
      </InputGroupText>
      <Input
        className="rounded-0 text-center appearance-none p-0"
        style={{
          height: "1rem",
          fontSize: "0.625rem",
          lineHeight: 0.8,
          width: "1.25rem",
        }}
        type="number"
        min={0}
        onChange={handleChange}
        value={value}
        data-testid="number-input"
        disabled={disabled}
      />
      <InputGroupText
        className="bg-gray-100 p-1"
        onClick={handlePlusClick}
        data-testid="+"
        style={{ height: "1rem" }}
      >
        <Icon
          iconName="plus"
          className={cx("icon-8", {
            "cursor-not-allowed opacity-20 disabled":
              +max === +value || disabled,
            "cursor-pointer": !(+max === +value),
          })}
        />
      </InputGroupText>
    </InputGroup>
  );
};
